import { render, staticRenderFns } from "./archiveBoxDownloadIcon.vue?vue&type=template&id=535bb54d&"
import script from "./archiveBoxDownloadIcon.vue?vue&type=script&lang=js&"
export * from "./archiveBoxDownloadIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports